module.exports = __webpack_public_path__ + "static/media/blue-bg.2bcb9264.png";